<template>
  <FullBoxVue class="shadowHover">
    <h1>Ver solicitudes</h1>
    <br />
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
          @input="buscarPeticiones"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headersAdmin"
        :items="peticiones"
        :search="search"
        @click:row="seleccionarPeticion"
        v-if="this.$dataUser[0].rol == 'Admin'"
        :items-per-page="limit"
        :page.sync="currentPage"
        :server-items-length="totalPeticiones"
        @update:page="cambiarPagina"
        @update:items-per-page="cambiarLimite"
      ></v-data-table>
      <v-data-table
        :headers="headers"
        :items="peticiones"
        :search="search"
        @click:row="seleccionarPeticion"
        :items-per-page="limit"
        :page.sync="currentPage"
        :server-items-length="totalPeticiones"
        @update:page="cambiarPagina"
        @update:items-per-page="cambiarLimite"
        v-else
      ></v-data-table>

    </v-card>
  </FullBoxVue>
</template>

<script>
import FullBoxVue from "../components/static/FullBox.vue";

import { getPeticiones } from "../api";

export default {
  data() {
    return {
      search: "",
      headers: [
        { text: "Id", value: "id",  align: ' d-none' },
        { text: "Nombre Servicio", value: "NOMBRE_SERVICIO" },
        { text: "Nombre SubServicio", value: "NOMBRE_SUBSERVICIO" },
        { text: "Nombre Empresa", value: "nombreEmpresa" },
        { text: "Nombre Usuario", value: "nombreCliente" },
        { text: "Evaluado", value: "nombreCandidato" },
        { text: "Cargo", value: "cargo" },
        { text: "Encargados actuales", value: "encargados" },
        { text: "Ciudad", value: "NOMBRE_CIUDAD" },
        { text: "Departamento", value: "NOMBRE_DEPARTAMENTO" },
        { text: "Fecha Creación", value: "fechaCreacion" },
        { text: "Estado", value: "estado" },
      ],
      headersAdmin: [
        { text: "Id", value: "id",  align: ' d-none' },
        { text: "Nombre Servicio", value: "NOMBRE_SERVICIO" },
        { text: "Nombre SubServicio", value: "NOMBRE_SUBSERVICIO" },
        { text: "Nombre Empresa", value: "nombreEmpresa" },
        { text: "Nombre Usuario", value: "nombreCliente" },
        { text: "Evaluado", value: "nombreCandidato" },
        { text: "Cargo", value: "cargo" },
        { text: "Encargados actuales", value: "encargados" },
        { text: "Coordinadores", value: "coordinadores" },
        { text: "Ciudad", value: "NOMBRE_CIUDAD" },
        { text: "Departamento", value: "NOMBRE_DEPARTAMENTO" },
        { text: "Fecha Creación", value: "fechaCreacion" },
        { text: "Estado", value: "estado" },
      ],
      peticiones: [],
      totalPeticiones: 0,
      currentPage: 1,
      limit: 15,
      idSolicitudSeleccionada: {},
      infoSolicitudRef: null,
      searchTimeout: null
    };
  },
  components: {
    FullBoxVue,
  },
  methods: {
    seleccionarPeticion(option) {
      this.idSolicitudSeleccionada = option;
      this.$router.push({ path: '/peticion/'+this.idSolicitudSeleccionada.id}).catch(()=>{});
    },
    cargarPeticiones() {
      getPeticiones(this.currentPage, this.limit, this.search).then(
        function (response) {
          if (response.data.data) {
            this.peticiones = response.data.data;
            this.totalPeticiones = response.data.pagination.total;
          } else {
            // Compatibilidad si aún retorna array directo
            this.peticiones = response.data;
          }
        }.bind(this)
      );
    },
    buscarPeticiones() {
      // Debounce la búsqueda
      clearTimeout(this.searchTimeout);
      this.currentPage = 1;
      this.searchTimeout = setTimeout(() => {
        this.cargarPeticiones();
      }, 1500);
    },
    cambiarPagina() {
      this.cargarPeticiones();
    },
    cambiarLimite() {
      this.currentPage = 1;
      this.cargarPeticiones();
    }
  },
  mounted() {
    this.cargarPeticiones();
  },
};
</script>

<style></style>
